// Layout constants shared between the scene shell (index.tsx — page chrome,
// sticky header, guard-clause states) and the Configuration tab, which needs
// the same content/page widths to stay visually aligned with the header.
export const CONTENT_MAX_WIDTH = '760px'
// Editor column + gap + preview column — the centered content block's cap so
// the whole page sits centered on wide screens rather than hugging the left.
export const PAGE_MAX_WIDTH = '1188px'

// The Olo webhook setup deep-link param/value (and the /live_updates path
// itself) moved to constants/liveUpdates.ts so RecoveryAI's routes.ts can
// import the same literals instead of repeating them — see that module's
// comment.
